import { memo } from 'react';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { TextTitle3, TextTitle1, TextHeadline, TextLabel1 } from '@cbhq/cds-web/typography';
import { RemoteImage } from '@cbhq/cds-web/media';
import { SummaryCard } from '@/components/common/SummaryCard';
import { EquitiesOverviewData } from './hooks/useTangorPortfolioData';

type Props = {
  data: EquitiesOverviewData;
};

export const TangorEquitiesOverview = memo(function TangorEquitiesOverview({ data }: Props) {
  const { isPhone, isPhoneLandscape } = useBreakpoints();
  const isMobile = isPhone || isPhoneLandscape;

  const header = <TextTitle3 as="h2">Overview</TextTitle3>;

  const statsContent = (
    <>
      {/* Largest asset */}
      <VStack alignItems="flex-start" gap={0.5} style={{ flex: 1 }}>
        <TextHeadline as="span" color="fgMuted">
          Largest asset
        </TextHeadline>
        <HStack alignItems="center" gap={1}>
          <RemoteImage
            source={data.largestAsset.imageUrl}
            size="m"
            shape="circle"
            alt={data.largestAsset.symbol}
          />
          <VStack alignItems="flex-start" gap={0}>
            <TextHeadline as="span">{data.largestAsset.symbol}</TextHeadline>
            <TextLabel1 as="span" color="fgMuted">
              {data.largestAsset.percentage}%
            </TextLabel1>
          </VStack>
        </HStack>
      </VStack>

      {/* Number of token assets */}
      <VStack alignItems="flex-start" gap={0.5} style={{ flex: 1 }}>
        <TextHeadline as="span" color="fgMuted">
          Number of token assets
        </TextHeadline>
        <TextTitle1 as="span">{data.numberOfTokenAssets}</TextTitle1>
      </VStack>

      {/* Next upcoming event */}
      <VStack alignItems="flex-start" gap={0.5} style={{ flex: 1 }}>
        <TextHeadline as="span" color="fgMuted">
          Next upcoming event
        </TextHeadline>
        <TextTitle1 as="span">{data.nextUpcomingEvent}</TextTitle1>
      </VStack>
    </>
  );

  return (
    <SummaryCard header={header} testID="tangor-equities-overview">
      {isMobile ? (
        <VStack paddingX={3} paddingBottom={2} gap={3} alignItems="flex-start" width="100%">
          {statsContent}
        </VStack>
      ) : (
        <HStack paddingX={3} paddingBottom={2} alignItems="flex-start" width="100%">
          {statsContent}
        </HStack>
      )}
    </SummaryCard>
  );
});
